import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from 'react-data-table-component';
//import ReactQuill from 'react-quill'; // ES6
//import 'react-quill/dist/quill.snow.css';

export default function Edit_Topico({ history }) {
  const [titulo, setTitulo] = useState("");
  const [descrHtml, setDescrHtml] = useState("");
  const [loading, setLoading] = useState("");
  const [itens, setItens] = useState([]);
  const [newitem, setNewItem] = useState("");
  const [idproduto, setIdproduto] = useState("");
  const [ordem, setOrdem] = useState("0");
  const [rowsSel, setRowsSel] = useState([]);

  const url_string = window.location.href;
  const param = url_string.split("/");
  const isMaster = localStorage.getItem("sgimaster");
  const empresaid = localStorage.getItem("sgiempresaid");
  const reqHeaders = { headers: { "x-tenantid": empresaid, isMaster } };

  // const modules = {
  //   toolbar: [
  //     [{ 'header': [1, 2, false] }],
  //     ['bold', 'italic', 'underline','strike', 'blockquote'],
  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
  //     ['link', 'image', 'video'],
  //     ['clean']
  //   ],
  // };
 
  // const formats = [
  //   'header',
  //   'bold', 'italic', 'underline', 'strike', 'blockquote',
  //   'list', 'bullet', 'indent',
  //   'link', 'image', 'video'
  // ];

  const columns = [
    {
      name: 'Ordem',
      selector: row => row.ordem,
      width: '5%'
    },
    {
      name: 'Titulo',
      selector: row => row.titulo,
    },
    {
      name: 'Data',
      selector: row => row.data,
    }
  ];

  const goToPage = (state) => {
    history.push('/subtopico/' + state._id);
  };

  async function loadProd() {
    let data;
    try {
      const response = await api.get(
        "/treinamentos/topico/" + param[4],
        reqHeaders
      );
      data = await response.data;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        alert(
          "Sem permissão para acessar este tópico (somente treinamentos da sua empresa)."
        );
        history.push("/produtos");
      }
      return false;
    }

    setTitulo(data[0].titulo);
    setDescrHtml(data[0].descrHtml);
    setIdproduto(data[0].idproduto);
    setOrdem(data[0].ordem);
    return true;
  }

  async function loadCompItens() {
    console.log("/treinamentos/subtopico/topico/" + param[4]);
    const query = "/treinamentos/subtopico/topico/" + param[4];
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setItens(data);
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const dataobj = {
      titulo,
      descrHtml,
      ordem
    };

    await api.put("/treinamentos/topico/" + param[4], dataobj, reqHeaders);
    setLoading(false);
    history.push("/produto/" + idproduto);
  }

  async function handleChangeHtml(html) {
    setDescrHtml(html);
  }

  const handleChange = (state) => {
    setRowsSel(state.selectedRows)
};

  async function addNewItem() {
    setLoading(true);

    const dataobj = {
      titulo: newitem,
      descrHtml: "<span>Descreva a ação aqui</span>",
      data: new Date(),
      idtopico: param[4],
    };

    await api.post("/treinamentos/subtopico", dataobj, reqHeaders);
    setLoading(false);
    loadCompItens();
  };

  async function handleRemove(id, item){
    if(rowsSel.length > 0){
      if (window.confirm('Confirma remoção dos itens selecionados ?')){
        setLoading(true);
        rowsSel.map(async (item) => {
            await api.delete('/treinamentos/subtopico/' + item._id, reqHeaders).then((res) => {
              if(res.data.error != undefined){
                  alert(res.data.error);
                  setLoading(false);
                  return;
              } else {
                loadCompItens();
                setLoading(false);
              }
          }).catch((error) => {
              alert(error);
              setLoading(false);
              return;
          });    
        });
      }
  } else {
    alert("Nenhum registro selecionado !")
  }
};

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setTimeout(() => {
      if (document.getElementById("menu_produto")) {
        document.getElementById("menu_produto").className = "active";
      }
    }, 50);
    (async () => {
      const ok = await loadProd();
      if (cancelled || !ok) {
        setLoading(false);
        return;
      }
      await loadCompItens();
      if (!cancelled) setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>{titulo}</h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box-footer">
                <button
                  className="btn btn-default"
                  style={{ marginRight: 8 }}
                  onClick={() => history.push('/produto/' + idproduto)}
                >
                  Voltar
                </button>

                <button
                  type="submit"
                  form="formCheck"
                  className="btn btn-success"
                  style={{ marginRight: 8 }}
                >
                  Salvar
                </button>
              </div>
              <div className="box box-primary">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80"></img>
                  </div>
                )}
                <form id="formCheck" className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Titulo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Nome do Produto"
                          className="form-control"
                          value={titulo}
                          required
                          maxLength={200}
                          onChange={(event) => setTitulo(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="ordem">
                        Ordem*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="ordem"
                          placeholder="Ordem na lista"
                          className="form-control"
                          value={ordem}
                          required
                          maxLength={2}
                          onChange={(event) => setOrdem(event.target.value)}
                        />
                      </div>
                    </div>

                    {/* <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Descrição*
                      </label>
                      <div className="col-sm-10">
                      <ReactQuill 
                      theme="snow"
                      value={descrHtml}
                      onChange={handleChangeHtml}
                      modules={modules}
                      formats={formats}
                       />
                      </div>
                    </div> */}



                    <div className="row">
                      <div className="col-xs-12">
                      <a className="btn btn-app" data-toggle="modal" data-target="#modal-newitem">
                          <i className="fa fa-plus"></i> Adicionar SubTópico
                        </a>
                        <a className="btn btn-app" onClick={() => {handleRemove('','')}}>
                          <i className="fa fa-remove"></i> Remover Selecionado
                        </a>
                        <div className="box">
                          {/* /.box-header */}
                          <DataTable
                          columns={columns}
                          data={itens}
                          onRowClicked={goToPage}
                          selectableRows
                          pointerOnHover
                          highlightOnHover
                          onSelectedRowsChange={handleChange}
                          noDataComponent={''}
                        />

                          <p>&nbsp;</p>
                          {/* /.box-body */}
                        </div>
                        {/* /.box */}
                      </div>
                    </div>
                  </div>

                  {/* <div className="box-footer">
                  <button
                      className="btn btn-default"
                      style={{marginRight:8}}
                      onClick={() => history.push("/produtos")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        className="modal fade"
        id="modal-newitem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Adicionar Novo SubTopico</h4>
            </div>
            <div className="modal-body">
              <input
                id="itemdesc"
                placeholder="Nome do SubTopico"
                className="form-control"
                required
                maxLength={200}
                value={newitem}
                onChange={(event) => setNewItem(event.target.value)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                onClick={() => addNewItem()}
                data-dismiss="modal"
                className="btn btn-primary"
              >
                Adicionar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      <Footer />
    </>
  );
}
